import { useTranslation } from "react-i18next";
import classes from "./FilterButton.module.scss";

const FilterButton = ({ name, value, text, isChecked, onChanged }) => {
  let id = value.replace(/ /g, "");
  const { t } = useTranslation();

  return (
    <div className={classes.FilterButton}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={() => onChanged(value)}
      />
      <label htmlFor={id}>{t(text)}</label>
    </div>
  );
};

export default FilterButton;
